module.exports = __webpack_public_path__ + "static/media/pic_quanping.9b0351d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageTic/pic_quanping.png
// module id = 589
// module chunks = 0